import { takeEvery, put, call } from 'redux-saga/effects';
import {getCustomer} from '../../../services/customer/customer-service'
import {receiveData, GET_CUSTOMER_REQUEST, requestFailed} from "../actions/get-customer-actions";

function* fetchData(action) {
    try {
        const response = yield call(
            getCustomer,
            action.payload
        );
        yield put(receiveData(response));
    } catch (error) {
        yield put(requestFailed(error));
    }
}

export function* watchGetCustomer() {
    yield takeEvery(GET_CUSTOMER_REQUEST, fetchData);
}
